import {Component, input, model, OnInit} from '@angular/core';
import {NavController} from "@ionic/angular";
import {WasteService} from "../../service/waste.service";
import {CommonService} from "../../service/common.service";
import * as _ from 'lodash';
import {SERVICE_ITEMS, ServiceItemVO} from "./items.const";
import {serviceSectionType} from "../../types/types";

@Component({
  selector: 'app-service-box-container',
  templateUrl: './service-box-container.component.html',
  styleUrls: ['./service-box-container.component.scss']
})
export class ServiceBoxContainerComponent implements OnInit {

  item = model<ServiceItemVO>();
  itemId = input<serviceSectionType>();

  constructor(private navController: NavController,
              private commonService: CommonService,
              private wasteService: WasteService) {
  }

  ngOnInit() {

    if (!this.item()) {
      console.log(this.itemId());
      this.item.set(_.find(SERVICE_ITEMS, item => item['id'] == this.itemId()));
    }
  }

  onOpenSection() {

    const idType: serviceSectionType = this.item().id;

    switch (idType) {
      case 'waste':
        this.wasteCallback();
        break;
      case 'avvisi-pubblici':
        this.publicAnnouncementsCallback();
        break;
      default:
        this.navController.navigateForward(this.item().link)
        break;
    }

  }

  wasteCallback() {
    if (this.wasteService.hasUserZone) {
      this.navController.navigateForward(['waste']);
    } else {
      this.navController.navigateForward(['/waste/settings']);
    }
  }

  publicAnnouncementsCallback() {
    this.commonService.onOpenLinkBrowser('https://www.comune.andria.bt.it/it/news-category/145030?type=3');
  }
}
